exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3KTTZe1sRkT6zB{box-shadow:0 8px 16px -4px rgba(9,30,66,.25),0 0 0 1px rgba(9,30,66,.08);background:#fff;border-radius:3px;border:1px solid rgba(9,30,66,.08);box-sizing:border-box;padding:32px;margin:0 auto;width:566px}._oTQ2Lfgs6sg37{display:flex}._39ON-9xbD_P-Sq{margin-right:16px}._39ON-9xbD_P-Sq img{border-radius:8px;display:inherit;height:64px;width:64px}._2aCL86eg9xE6Kx{font-size:64px;line-height:64px}.mjV6Pv9gfaf5Ie{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;line-height:64px;margin:0}._2w4pCriplAmmSF{border-bottom:1px solid #dfe1e6;color:#6b778c;font-size:12px;font-style:italic;margin:8px 0;padding-bottom:32px;text-align:center}._2KQggd38V2ndX1{margin:0 auto;padding-top:24px;text-align:center;width:300px}._38F4_j_dagNV-K{font-weight:700}._1DPiNylrTajoX{color:#6b778c;font-size:12px;margin-bottom:8px}._1gpbjL7KCw78dy{color:#0079bf;cursor:pointer;display:inline-block}", ""]);

// exports
exports.locals = {
	"moonshotBillingWrapper": "_3KTTZe1sRkT6zB",
	"moonshotBillingHeading": "_oTQ2Lfgs6sg37",
	"moonshotBillingOrgImage": "_39ON-9xbD_P-Sq",
	"moonshotBillingOrgIcon": "_2aCL86eg9xE6Kx",
	"moonshotBillingOrgName": "mjV6Pv9gfaf5Ie",
	"moonshotBillingCancellationCopy": "_2w4pCriplAmmSF",
	"moonshotBillingSkip": "_2KQggd38V2ndX1",
	"moonshotBillingSkipHeading": "_38F4_j_dagNV-K",
	"moonshotBillingSkipDescription": "_1DPiNylrTajoX",
	"moonshotBillingSkipCTA": "_1gpbjL7KCw78dy"
};